import { render, staticRenderFns } from "./StorageRequestStatusCell.vue?vue&type=template&id=48ee4112&"
import script from "./StorageRequestStatusCell.vue?vue&type=script&lang=js&"
export * from "./StorageRequestStatusCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports